import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { getMyTeams } from '../../../service/dataCategorizationService';

/**
 * TeamSelector Component
 *
 * Provides team selection and save results option
 *
 * @component
 */
const TeamSelector = ({ 
  selectedTeam = '', 
  onTeamChange, 
  saveResults = true, 
  onSaveResultsChange, 
  disabled = false 
}) => {
  const [teamOptions, setTeamOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState(null);

  // Direct API call on mount — no Redux/saga
  useEffect(() => {
    const fetchTeams = async () => {
      setLoading(true);
      setFetchError(null);
      try {
        const response = await getMyTeams();
        const data = response.data || [];
        const options = Array.isArray(data)
          ? data.map(team => typeof team === 'string'
              ? { label: team, value: team }
              : { label: team.label || team.name || team.value, value: team.value || team.name })
          : [];
        setTeamOptions(options);
      } catch (err) {
        console.error('[TeamSelector] Failed to fetch teams:', err);
        setFetchError('Failed to load teams');
      } finally {
        setLoading(false);
      }
    };

    fetchTeams();
  }, []);

  return (
    <div className="team-selector">
      <div className="p-field">
        <label htmlFor="team-select" style={{ color: '#343A40', fontSize: '15px', fontWeight: 600 }}>
          Select Team <span style={{ color: '#dc3545', fontSize: '16px' }}>*</span>
        </label>
        <Dropdown
          id="team-select"
          value={selectedTeam}
          options={teamOptions}
          onChange={(e) => onTeamChange(e.value)}
          placeholder={loading ? 'Loading teams...' : fetchError ? fetchError : 'Choose a team for categorization'}
          disabled={disabled || loading}
          className="team-dropdown"
          showClear={selectedTeam ? true : false}
        />
        {!selectedTeam && !loading && (
          <small className="field-description" style={{ color: '#dc3545', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '6px', marginTop: '6px' }}>
            <i className="pi pi-exclamation-triangle" style={{ fontSize: '14px' }}></i>
            Team selection is required before uploading files
          </small>
        )}
        {selectedTeam && (
          <small className="field-description" style={{ color: '#28a745', fontWeight: 500, display: 'flex', alignItems: 'center', gap: '6px', marginTop: '6px' }}>
            <i className="pi pi-check-circle" style={{ fontSize: '14px' }}></i>
            Team selected - you can now upload files below
          </small>
        )}
      </div>

      <div className="p-field-checkbox">
        <Checkbox
          inputId="save-results"
          checked={saveResults}
          onChange={(e) => onSaveResultsChange(e.checked)}
          disabled={disabled}
        />
        <label htmlFor="save-results">
          Save categorization results to database
        </label>
      </div>
    </div>
  );
};

TeamSelector.propTypes = {
  selectedTeam: PropTypes.string,
  onTeamChange: PropTypes.func.isRequired,
  saveResults: PropTypes.bool,
  onSaveResultsChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default TeamSelector;
